<template>
   <div class="container">
      <loading :active.sync="isLoading"></loading>
      <table class="table">
         <thead>
            <th>品名</th>
            <th>數量</th>
         </thead>
         <tbody>
            <tr v-for="item in cart.cartItems" :key="item.suuid">
               <td class="align-middle">{{ item.product_name }}</td>
               <td class="align-middle">{{ item.qty }}</td>
            </tr>
         </tbody>
      </table>

      <form class="col-md-12">
         <div class="form-group">
            <div class="form-group">
               <label for="company_name">公司名稱</label>
               <input
                  type="text"
                  class="form-control"
                  name="company_name"
                  id="company_name"
                  :class="{ 'is-invalid': errors.has('company_name') }"
                  v-model="form.company_name"
                  v-validate="'required'"
                  placeholder="請輸入您的公司名稱"
               />
               <span class="text-danger" v-if="errors.has('company_name')"
                  >公司名稱必須輸入</span
               >
            </div>

            <div class="form-group">
               <label for="construction_name">工地名稱</label>
               <input
                  type="text"
                  class="form-control"
                  name="construction_name"
                  id="construction_name"
                  :class="{ 'is-invalid': errors.has('construction_name') }"
                  v-model="form.construction_name"
                  v-validate="'required'"
                  placeholder="輸入工地名稱"
               />
               <span class="text-danger" v-if="errors.has('construction_name')"
                  >工地名稱必須輸入</span
               >
            </div>

            <div class="form-group">
               <label for="memberaddress">送貨地址</label>
               <input
                  type="address"
                  class="form-control"
                  name="address"
                  :class="{ 'is-invalid': errors.has('address') }"
                  id="memberaddress"
                  v-model="form.address"
                  v-validate="'required'"
                  placeholder="請輸工地送貨地址"
               />
               <span class="text-danger" v-if="errors.has('address')"
                  >工地送貨地址不得留空，謝謝</span
               >
            </div>

            <div class="form-group">
               <label for="construction_building"
                  >工地棟(區)別(假設有指定請備註)</label
               >
               <input
                  type="text"
                  class="form-control"
                  name="construction_building"
                  id="construction_building"
                  :class="{ 'is-invalid': errors.has('construction_building') }"
                  v-model="form.construction_building"
                  placeholder="輸入工地棟(區)別"
               />
            </div>

            <div class="form-group">
               <label for="construction_floor">工地樓層(假設有指定請備註)</label>
               <input
                  type="text"
                  class="form-control"
                  name="construction_floor"
                  id="construction_floor"
                  v-model="form.construction_floor"
                  placeholder="輸入工地樓層"
               />
            </div>

            <div class="form-group">
               <label for="membername">收件聯絡人1姓名</label>
               <input
                  type="text"
                  class="form-control"
                  name="name"
                  id="membername"
                  :class="{ 'is-invalid': errors.has('name') }"
                  v-model="form.name"
                  v-validate="'required'"
                  placeholder="請輸入收件聯絡人1姓名"
               />
               <span class="text-danger" v-if="errors.has('name')"
                  >請輸入收件人姓名</span
               >
            </div>

            <div class="form-group">
               <label for="membertel">收件聯絡人1電話</label>
               <input
                  type="text"
                  class="form-control"
                  id="membertel"
                  v-model="form.mobile"
                  placeholder="請收件聯絡人1電話"
               />
            </div>
            <div class="form-group">
               <label for="membername">收件聯絡人2姓名</label>
               <input
                  type="text"
                  class="form-control"
                  name="name"
                  id="membername"
                  v-model="form.name2"
                  placeholder="輸入收件聯絡人2姓名"
               />
            </div>

            <div class="form-group">
               <label for="membertel">收件聯絡人2電話</label>
               <input
                  type="text"
                  class="form-control"
                  id="membertel"
                  v-model="form.mobile2"
                  placeholder="請輸入收件聯絡人2電話"
               />
            </div>
            <!-- <label for="title">地址命名(作為之後可地址選用，可以不修改讓系統命名如下)</label>
            <input
               type="text"
               class="form-control"
               name="title"
               id="title"
               v-model="form.title"
            /> -->
         </div>
         <div class="form-group">
            <label for="note">留言</label>
            <textarea
               name
               id
               class="form-control"
               cols="30"
               rows="10"
               v-model="form.note"
            ></textarea>
         </div>
         <div class="text-right">
            <button class="btn btn-danger" @click.prevent="confirm()">
               送出訂單
            </button>
         </div>
      </form>
   </div>
</template>

<script>
export default {
   data() {
      return {
         isLoading: false,
         recipientList: [],
         cart: {},
         member: {},
         form: {
            // title: "",
            // company_name: "",
            // address: "",
            // construction_name: "",
            // construction_building: "",
            // construction_floor: "",
            // name: "",
            // email: "",
            // mobile: "",
            // day_telephone: "",
            // city: "",
            // address_additional: "",
            // note: "",
         },
         order_no: "",
      };
   },
   methods: {
      confirm() {
         const vm = this;
         vm.isLoading = true;
        //  console.log('form:', vm.form);
         this.$ecServiceInstance
            .post("/mall/shoppingCart/setRecipient", {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
               recipient: this.form
              //  recipient: {
              //     company_name: vm.form.company_name,
              //     name: vm.form.name,
              //     mobile: vm.form.mobile,
              //     name2: vm.form.name2,
              //     mobile2: vm.form.mobile2,
              //     construction_name: vm.form.construction_name,
              //   //   day_telephone: vm.form.day_telephone,
              //     email: vm.form.email,
              //     country: "TW",
              //     city: vm.form.city,
              //     address: vm.form.address,
              //     construction_building: vm.form.construction_building,
              //     construction_floor: vm.form.construction_floor,
              //     construction_name: vm.form.construction_name,
              //     address_additional:vm.form.address_additional,
              //       //  vm.form.construction_building +
              //       //  " " +
              //       //  vm.form.construction_floor +
              //       //  " " +
              //       //  vm.form.address_additional,
              //     company_name: vm.form.company_name,
              //   //   note: vm.form.construction_name + vm.form.note,
              //     note: vm.form.note
              //  }
            })
            .then((response) => {
               localStorage.setItem("form", JSON.stringify(vm.form));
               localStorage.setItem("cart", JSON.stringify(vm.cart));
               this.checkOut();
               vm.isLoading = false;
            })
            .catch((e) => {
               console.erroe(e);
            });
      },
      checkOut() {
         const vm = this;
         vm.isLoading = true;
         this.$ecServiceInstance
            .post("/mall/shoppingCart/checkout", {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {

               this.order_no = response.data.data.order_mas_no;
               this.$router.push(
                  `/customer/success/?order_no=${this.order_no}`
               );
               vm.isLoading = false;
            })
            .catch((e) => {
               console.error(e);
            });
      },

      getCart() {
         const vm = this;
         vm.isLoading = true;
         this.$ecServiceInstance
            .post("/mall/shoppingCart/get", {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {
               if (response) {
                  vm.cart = response.data.shoppingCart;
                  // console.log("cart:", vm.cart);
               }
               vm.isLoading = false;
            });
      },
      getRecipientList() {
         this.$ecServiceInstance
            .post(`/mall/shoppingCart/getRecipientList?page=1&page_size=10`, {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {
               if (response) {
                  this.recipientList = response.data.data.list;
               }
               this.isLoading = false;
            });
      },
   },
    watch: {
      // form() {
      //   this.form.title = this.form.company_name + this.form.construction_name;
      //   console.log('form:', this.form);
      // },
      "form.company_name": function(){
        this.form.title = this.form.company_name + this.form.construction_name;
      },
      "form.construction_name": function(){
        this.form.title = this.form.company_name + this.form.construction_name;
      },

   },
   created() {
      this.member = JSON.parse(localStorage.getItem("member"));
      this.form.name = this.member.name;
      this.form.email = this.member.email;
      var oldForm = localStorage.getItem("form");
      // console.log("oldForm:", oldForm);
      if (oldForm) {
         this.form = JSON.parse(oldForm);
         this.form.title =
            this.form.company_name + "-" + this.form.construction_name;
      }
      this.getCart();
      this.getRecipientList();
   },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CustomerCheckout.vue